import styled, { css, createGlobalStyle } from 'styled-components';

export const TourHighlightGlobalStyle = createGlobalStyle`
  .tour-highlight-element {
    position: relative !important;
    z-index: 10001 !important;
    background-color: ${({ theme }) => theme.colors.white}; 
    border-radius: 8px;
    pointer-events: none;
    transition: all 0.3s ease;
  }
`;

export const TourBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--black-10, rgba(0, 0, 0, 0.10));
  backdrop-filter: blur(3.7px);
  
  z-index: 10000;
  opacity: 0;
  animation: fadeIn 0.3s forwards;

  @keyframes fadeIn {
    to { opacity: 1; }
  }
`;

export interface NextStepModalProps {
  $top?: string;
  $left?: string;
  $right?: string;
  $bottom?: string;
  $transform?: string;
  $showArrow?: boolean;
  $arrowTop?: string;
  $arrowBottom?: string;
  $arrowLeft?: string;
  $arrowRight?: string;
  $arrowDirection?: 'left' | 'up' | 'down' | 'right';
}

export const NextStepModalWrapper = styled.div<NextStepModalProps>`
  position: fixed;
  z-index: 10002;
  width: min(443px, calc(100vw - 32px));
  pointer-events: none;
  overflow: visible;

  top: ${({ $top }) => $top || 'auto'};
  left: ${({ $left }) => $left || 'auto'};
  right: ${({ $right }) => $right || 'auto'};
  bottom: ${({ $bottom }) => $bottom || 'auto'};
  transform: ${({ $transform }) => $transform || 'none'};

  &::before {
    content: '';
    position: absolute;
    display: ${({ $showArrow }) => ($showArrow ? 'block' : 'none')};
    pointer-events: none;
    width: 0;
    height: 0;
    border-style: solid;

    top: ${({ $arrowTop }) => $arrowTop || 'auto'};
    bottom: ${({ $arrowBottom }) => $arrowBottom || 'auto'};
    
    ${({ $arrowDirection, $arrowLeft, $arrowRight }) => {
    switch ($arrowDirection) {
      case 'up':
        return css`
            border-width: 0 16px 20px 16px;
            border-color: transparent transparent #b26eff transparent;
            left: ${$arrowLeft || 'auto'};
            right: auto;
          `;
      case 'down':
        return css`
            border-width: 20px 16px 0 16px;
            border-color: #642adb transparent transparent transparent;
            left: ${$arrowLeft || 'auto'};
            right: auto;
          `;

      case 'right':
        return css`
            border-width: 16px 0 16px 26px; 
            border-color: transparent transparent transparent #b26eff;
            
            left: auto; 
            right: ${$arrowRight || '-26px'};
          `;

      case 'left':
      default:
        return css`
            border-width: 16px 26px 16px 0;
            border-color: transparent #b26eff transparent transparent;
            
            left: ${$arrowLeft || '-26px'};
            right: auto;
          `;
    }
  }}
  }

  @media (max-width: 900px) {
    top: auto !important;
    bottom: 20px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    
    &::before {
      display: none;
    }
  }

  @media (max-height: 575px) {
    top: auto !important;
    bottom: 0 !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
`;

export const NextStepModal = styled.div<{ $maxHeight?: number }>`
  background: linear-gradient(to bottom, #b26eff, #642adb);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  padding: 24px;
  width: 100%;
  
  max-height: ${({ $maxHeight }) => $maxHeight ? `${$maxHeight}px` : 'calc(100vh - 32px)'};
  overflow-y: auto;
  pointer-events: auto;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);

  .step-count-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .skip {
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      background: none;
      border: none;
      color: white;
    }
  }

  .title-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .step-count {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
  }

  .step-title {
    font-size: 19px;
    font-weight: 700;
  }

.step-description {
    display: block;
    width: 100%;
    padding: 1rem 0;

    p, li {
      font-size: 16px;
      font-weight: 400;
      line-height: 1.5;
      letter-spacing: 0.2px;
      color: white;
      margin-top: 0; 
      margin-bottom: 20px; 
    }

    p:last-child {
      margin-bottom: 0;
    }

    strong {
      display: inline;
      font-weight: 600;
    }
  }

  .buttons-row {
    width: 100%;
    display: flex;
    gap: 30px;
    margin-left: auto;
  }

  .buttons-row .next, .buttons-row .end-tour {
    margin-left: auto;
  }

  .next, .prev {
    color: white;
    font-size: 14px;
    font-weight: 600;
    border: 1px solid white;
    padding: 0 16px;
    border-radius: 31px;
    display: flex;
    justify-content: space-between;
    width: 139px;
    height: 48px;
    align-items: center;
    cursor: pointer;
    background: transparent;
  }

  li {
    list-style: none;
    padding-left: 10px;
    margin: -5px;
  }

  @media (max-height: 700px) {
    .step-title {
      font-size: 18px;
      margin-bottom: 12px;
    }
    .next {
      height: 44px;
    }
  }
`;